import type { QueryClient } from "@tanstack/react-query";
import { createContext, useContext } from "react";

export interface AuthQuerySetup {
  queryClient: QueryClient;
  isAuthLoading: boolean;
  authError: Error | undefined;
  isAuthenticated: boolean;
  isAuthSetupComplete: boolean;
  sessionExpired: boolean;
}

/**
 * Published once per portal by AuthenticatedGuard. Without it, every component
 * that only wants `isAuthSetupComplete` would run the whole Auth0 setup again:
 * its own token fetch, its own activity listeners, its own refresh interval,
 * and another error interceptor on the shared API client.
 */
const AuthQuerySetupContext = createContext<AuthQuerySetup | null>(null);

export const AuthQuerySetupProvider = AuthQuerySetupContext.Provider;

export function useSharedAuthQuerySetup(): AuthQuerySetup | null {
  return useContext(AuthQuerySetupContext);
}
